export const INDUSTRY_CENTER_ARTICLE_RIGHT_RAIL_CONTENT = {
  data: '/editorial/ao-categories',
};
